var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#010101;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_71",
    "data-name": "Group 71"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M10.5,16.4a5.9,5.9,0,1,1,5.9-5.9A5.91,5.91,0,0,1,10.5,16.4Zm0-10a4.1,4.1,0,1,0,4.1,4.1A4.11,4.11,0,0,0,10.5,6.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    className: "cls-1",
    d: "M10.5,6A4.5,4.5,0,1,0,15,10.5,4.5,4.5,0,0,0,10.5,6m0-1A5.5,5.5,0,1,1,5,10.5,5.5,5.5,0,0,1,10.5,5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M18.5,19.4a.9.9,0,0,1-.64-.26l-3-3a.91.91,0,0,1,1.28-1.28l3,3a.9.9,0,0,1,.26.64.91.91,0,0,1-.27.64.86.86,0,0,1-.63.26Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line_24",
    "data-name": "Line 24",
    className: "cls-1",
    d: "M18.5,19a.47.47,0,0,1-.35-.15l-3-3a.49.49,0,0,1,.7-.7l3,3a.48.48,0,0,1,0,.7A.47.47,0,0,1,18.5,19Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.490ed82c06853176f15c8a33f829438c.svg";
export { ForwardRef as ReactComponent };